module.exports = __webpack_public_path__ + "img/coming-soon.9cc1bd28.webp";